<template>
  <v-container fluid>
    <div class="absolute" v-if="loader">
      <Spinner />
    </div>
    <v-row>
      <v-col>
        <v-card class="pa-3">
          <v-card-title>
            <b>Orden de servicios</b>
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Buscar orden"
              single-line
              hide-details
            ></v-text-field>
            <v-spacer></v-spacer>
            <v-switch
              v-model="switchOrden"
              @click="initialize()"
              inset
              :label="switchOrden ? 'Actuales' : 'Historial'"
              class="mr-md-10 mr-0"
            ></v-switch>
            <div class="orden-acciones">
              <v-btn
                color="info"
                dark
                class="mt-10 mt-sm-0 d-none d-md-block"
                @click="initialize()"
              >
                <v-icon>mdi-refresh</v-icon>
              </v-btn>
              <nuevo-cliente />
            </div>
          </v-card-title>
          <v-data-table
            :headers="headers"
            :items="ordenes"
            :search="search"
            :single-expand="true"
            :expanded.sync="expanded"
            :options.sync="options"
            :loading="loader"
            item-key="_id"
            show-expand
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
          >
            <template v-slot:item.status="{ item }">
              <span>{{
                item.status == 1
                  ? "Recepcion"
                  : item.status == 2
                  ? "En proceso"
                  : item.status == 3
                  ? "Terminado"
                  : item.status == 4
                  ? "Finalizada"
                  : "Estatus no definido"
              }}</span>
            </template>
            <template v-slot:item.actions="{ item }">
              <div class="d-flex flex-column flex-md-row">
                <v-btn
                  elevation="2"
                  small
                  color="success"
                  v-show="item.status < 4"
                  @click="puntoDeVenta(item)"
                >
                  <v-icon @click="puntoDeVenta(item)"
                    >mdi-cart-arrow-down</v-icon
                  >
                </v-btn>
                <salida :item="item" :pagina="1" v-if="item.status == 3" />
                <contrato :item="item" :pagina="1" v-if="item.status == 10" />
                <v-btn
                  color="error"
                  small
                  elevation="2"
                  v-if="item.status == 1"
                  @click="modalCambiarStatus(item._id, -1)"
                >
                  <v-icon class="mr-1">mdi-car-off</v-icon>
                </v-btn>
                <v-btn
                  v-if="item.status != 3 && item.status < 4"
                  color="info"
                  @click="modalCambiarStatus(item._id, item.status)"
                  elevation="2"
                  small
                  class="ml-1 my-2 my-md-0"
                  ><v-icon class="mr-1">{{
                    item.status == 1 ? "mdi-car-info" : "mdi-car-settings"
                  }}</v-icon
                  >{{
                    item.status == 1 ? "Entra a taller" : "Terminó servicio"
                  }}</v-btn
                >
              </div>
            </template>
            <template v-slot:expanded-item="{ headers, item }">
              <td :colspan="headers?.length" class="pa-3">
                <v-row class="ordenesAuto">
                  <v-col cols="12" md="4" class="carruselAuto">
                    <v-carousel
                      v-if="
                        item.images &&
                        item.images != null &&
                        item?.images?.length != 0
                      "
                    >
                      <v-carousel-item
                        v-for="(image, i) in item.images"
                        :key="i"
                        :src="image"
                        reverse-transition="fade-transition"
                        transition="fade-transition"
                      ></v-carousel-item>
                    </v-carousel>
                    <v-carousel
                      v-else-if="
                        item.vehicle &&
                        item.vehicle.images &&
                        item.vehicle?.images?.length != 0
                      "
                    >
                      <v-carousel-item
                        v-for="(image, i) in item.vehicle.images"
                        :key="i"
                        :src="image"
                        reverse-transition="fade-transition"
                        transition="fade-transition"
                      ></v-carousel-item>
                    </v-carousel>
                    <div v-else>
                      <v-file-input
                        v-model="cambio_images"
                        counter
                        multiple
                        show-size
                        filled
                        prepend-icon="mdi-camera"
                        label="Agregar Imágenes"
                        accept="image/*"
                        @change="onFileChange($event, item)"
                      ></v-file-input>
                      <v-btn
                        :disabled="cambio_images ? false : true"
                        @click="subirImg(item)"
                        color="info"
                        elevation="3"
                        ><v-icon class="mr-2">mdi-image</v-icon> Subir
                        imagen</v-btn
                      >
                    </div>
                  </v-col>
                  <v-col cols="12" md="4" class="detalleAuto">
                    <v-icon class="float-left">mdi-account</v-icon>
                    <h4>{{ item.order }}</h4>
                    <p>
                      <b>Nombre: </b>{{ item.client ? item.client?.name : "" }}
                      <br />
                      <b>Apellido Paterno: </b
                      >{{ item?.client ? item.client?.first_lastname : "" }}
                      <br />
                      <b>Apellido Materno: </b
                      >{{ item?.client?.second_lastname || "" }} <br />
                      <b>Email: </b>{{ item?.client?.email }} <br />
                      <b>Teléfono: </b>{{ item?.client?.telephones[0] }} <br />
                    </p>
                    <p v-if="item?.vehicle?.model">
                      <v-icon>mdi-car</v-icon>
                      <b>Vehículo:</b> {{ item?.vehicle?.model?.name || "" }}
                      <br />
                      <b>Año:</b> {{ item?.vehicle?.year }} <br />
                      <b>Marca:</b>
                      {{
                        item.vehicle &&
                        item.vehicle?.model &&
                        item.vehicle?.model?.brand
                          ? item.vehicle?.model?.brand?.name
                          : ""
                      }}
                      <br />
                      <b>Color:</b> {{ item.vehicle?.colour }} <br />
                      <b>Placas:</b> {{ item.vehicle?.license_plate }} <br />
                      <b># de Cilindros:</b> {{ item.vehicle?.cylenders }}
                      <br />
                      <b># de Serie:</b> {{ item.vehicle?.serial_number }}
                      <br />
                      <b>Kilometraje:</b> {{ fm.from(item.km || item.vehicle?.mileage) }} <br />
                      <b>Llave:</b> {{ item.keyCar == 1 ? 'SI' : 'NO' }} <br />
                      <b>Aire Acondicionado:</b> {{ item.air == 1 ? 'SI' : (item.air == 3 ? 'NO FUNCIONA' : 'NO') }} <br />
                    </p>
                  </v-col>
                  <v-col cols="12" md="4" class="detalleAuto">
                    <v-icon>mdi-cog</v-icon>
                    <h5>Servicios solicitados:</h5>
                    <span v-for="service in item.services" :key="service._id">
                      <b>-{{ service.service?.name || "" }}</b> <br />
                      <b>Detalles de la orden:</b><br />
                      {{ item.detail?.toUpperCase() }} <br />
                      <b>Autoriza Lavado:</b>
                      {{ item.washed == 1 ? 'Autorizado' : 'No Autorizado' }}
                      <br />
                      <b>Mecánico:</b>
                      {{ getNombreMecanico(service?.mechanics) }}
                      <br />
                    </span>
                    <p v-if="!item.serial_factura">
                      <v-btn
                        @click="abrirFacturacion(item._id, item.order)"
                        small
                        color="success"
                        class="ma-3"
                        ><v-icon small title="Facturar venta" class="mr-2"
                          >mdi-signature-freehand</v-icon
                        >
                        Facturar</v-btn
                      >
                    </p>
                    <v-text v-else
                      >Esta orden cuenta con la factura:
                      <b>{{ item.serial_factura }}</b></v-text
                    >
                    <div>
                    <v-btn
                      outlined
                      small
                      color="info"
                      class="mt-3 btn"
                      @click="editar(item)"
                      ><v-icon small>mdi-pencil</v-icon> Editar</v-btn
                    >
                    <v-btn
                      color="info"
                      small
                      class="mt-3 btn btnOrdenDigital"
                      @click="abrirOrdenDigital(item)"
                    >
                      <v-icon icon="mdi-vuetify">mdi-file-sign</v-icon>
                      {{
                        item.sign_flag ? btnTextOrdenDigital : "Orden digital"
                      }}
                    </v-btn>
                    <v-btn
                    outlined
                      color="#707070"
                      small
                      class="mt-3 btn btnOrdenDigital"
                      @click="ticketTecnico(item)"
                    >
                      <v-icon icon="mdi-vuetify">mdi-invoice-list-outline</v-icon>
                      Ticket técnico
                    </v-btn>
                    </div>
                  </v-col>
                </v-row>
              </td>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
      <v-dialog v-model="dialog" persistent max-width="450">
        <v-card class="card-container-ord">
          <v-card-title class="item-center headline">
            {{
              status == 1
                ? "¿El vehículo va a ingresar al taller?"
                : status == 2
                ? "¿El vehículo salió del servicio?"
                : status == -1
                ? "¿Quieres dar de baja la orden?"
                : "¿Deseas registrar la salida del vehículo?"
            }}
          </v-card-title>
          <v-card-text class="item-center"
            >Se requiere de confirmación.</v-card-text
          >
          <v-card-actions class="item-center">
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" text @click="dialog = false">
              Cancelar
            </v-btn>
            <v-btn color="green darken-1" text @click="cambiarStatus">
              Aceptar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        transition="dialog-bottom-transition"
        max-width="700"
        v-model="modal"
        persistent
      >
        <template v-slot:default="modal">
          <v-card>
            <v-toolbar color="primary" dark>Editar servicio</v-toolbar>
            <v-card-text>
              <div v-for="(service, counter) in service" v-bind:key="counter">
                <v-row justify="end"> </v-row>
                <v-row class="pa-2">
                  <v-col cols="12" sm="6">
                    <v-select
                      v-model="service.service._id"
                      :items="servicio"
                      item-text="name"
                      item-value="_id"
                      label="Servicio"
                      filled
                    ></v-select>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-select
                      v-model="service.mechanics[0]._id"
                      :items="mecanico"
                      item-text="name"
                      item-value="_id"
                      label="Mecánico"
                      filled
                    ></v-select>
                  </v-col>
                  <v-col cols="12">
                    <v-textarea
                      filled
                      v-model="service.detail"
                      name="detalles"
                      label="Detalles"
                      value=""
                      rows="3"
                    ></v-textarea>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-text-field
                      label="Saldo a favor"
                      v-model="saldo_favor"
                      type="number"
                      filled
                    ></v-text-field>
                  </v-col>
                </v-row>
              </div>
            </v-card-text>
            <v-card-actions class="justify-end">
              <v-btn text @click="modal.value = false">Cancelar</v-btn>
              <v-btn text @click="guardarServicio">Guardar</v-btn>
            </v-card-actions>
          </v-card>
        </template>
      </v-dialog>
      <v-dialog
        transition="dialog-top-transition"
        max-width="600"
        v-model="facturar"
      >
        <template>
          <v-card>
            <v-toolbar color="primary" dark>Facturar venta</v-toolbar>
            <v-card-text>
              <v-container>
                <b>Datos de Cliente</b>
                <v-row>
                  <v-col cols="12" sm="12">
                    <v-autocomplete
                      v-model="rfc"
                      :items="rfcs"
                      item-text="razon_social"
                      label="Seleccione un cliente registrado"
                      return-object
                      required
                      persistent-hint
                      single-line
                      clearable
                    >
                    </v-autocomplete>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field
                      v-if="rfc != null"
                      v-model="rfc.name"
                      label="Nombre"
                      type="text"
                      :rules="[rules.required]"
                      validate-on-blur
                      filled
                      disabled
                    ></v-text-field>
                    <v-text-field
                      v-else
                      v-model="ordenAfacturar.receptor.name"
                      label="Nombre*"
                      type="text"
                      :rules="[rules.required]"
                      validate-on-blur
                      placeholder="Juan"
                      filled
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field
                      v-if="rfc != null"
                      v-model="rfc.first_lastname"
                      label="Apellido Paterno*"
                      :rules="[rules.required]"
                      validate-on-blur
                      placeholder="López"
                      filled
                      disabled
                    ></v-text-field>
                    <v-text-field
                      v-else
                      v-model="ordenAfacturar.receptor.first_lastname"
                      label="Apellido Paterno*"
                      :rules="[rules.required]"
                      validate-on-blur
                      placeholder="López"
                      filled
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field
                      v-if="rfc != null"
                      label="Apellido Materno"
                      v-model="rfc.second_lastname"
                      placeholder="Perez"
                      filled
                      disabled
                    ></v-text-field>
                    <v-text-field
                      v-else
                      v-model="ordenAfacturar.receptor.second_lastname"
                      label="Apellido Paterno*"
                      :rules="[rules.required]"
                      validate-on-blur
                      placeholder="Perez"
                      filled
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field
                      v-if="rfc != null"
                      v-model="rfc.telephones"
                      label="Celular*"
                      :rules="[rules.required, rules.regex]"
                      validate-on-blur
                      filled
                      :max="10"
                      type="tel"
                      disabled
                    ></v-text-field>
                    <v-text-field
                      v-else
                      v-model="ordenAfacturar.receptor.telephones"
                      label="Celular*"
                      :rules="[rules.required, rules.regex]"
                      validate-on-blur
                      filled
                      :max="10"
                      type="tel"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field
                      v-if="rfc == null"
                      v-model="ordenAfacturar.receptor.rfc"
                      label="RFC Nuevo*"
                      :rules="[rules.required, rules.regexRFC]"
                      validate-on-blur
                      type="text"
                      required
                      v-uppercase
                      maxlength="13"
                    ></v-text-field>
                    <v-text-field
                      v-else
                      v-model="rfc.rfc"
                      label="RFC*"
                      class="capitalize"
                      :rules="[rules.required, rules.regexRFC]"
                      validate-on-blur
                      type="text"
                      required
                      v-uppercase
                      maxlength="13"
                      disabled
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field
                      v-if="rfc != null"
                      v-model="rfc.razon_social"
                      label="Razon social"
                      type="text"
                      disabled
                    ></v-text-field>
                    <v-text-field
                      v-else
                      v-model="ordenAfacturar.receptor.razon_social"
                      label="Razon social*"
                      class="capitalize"
                      :rules="[rules.required, rules.regexRZ]"
                      validate-on-blur
                      v-uppercase
                      type="text"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field
                      v-if="rfc != null"
                      v-model="rfc.email"
                      label="Correo"
                      :rules="[rules.required, rules.regexEmail]"
                      validate-on-blur
                      type="email"
                      disabled
                    ></v-text-field>
                    <v-text-field
                      v-else
                      v-model="ordenAfacturar.receptor.email"
                      label="Correo*"
                      type="email"
                      :rules="[rules.required, rules.regexEmail]"
                      validate-on-blur
                      placeholder="Ingresar emails separado por ;"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-autocomplete
                      v-if="rfc != null"
                      v-model="rfc.regimen_fiscal"
                      :items="regimen"
                      filled
                      item-value="value"
                      item-text="text"
                      class="capitalize"
                      label="Regimen fiscal*"
                      :disabled="isGeneralPublic"
                      :rules="[rules.required]"
                      validate-on-blur
                    ></v-autocomplete>
                    <v-autocomplete
                      v-else
                      v-model="ordenAfacturar.receptor.regimen_fiscal"
                      :items="regimen"
                      filled
                      item-value="value"
                      item-text="text"
                      class="capitalize"
                      label="Regimen fiscal*"
                      :rules="[rules.required]"
                      validate-on-blur
                      :disabled="isGeneralPublic"
                    ></v-autocomplete>
                  </v-col>
                  <v-col v-if="!isGeneralPublic" cols="12" sm="6">
                    <v-text-field
                      v-if="rfc != null"
                      v-model="rfc.codigo_postal"
                      label="Codigo postal*"
                      type="text"
                      :rules="[rules.required]"
                      validate-on-blur
                      disabled
                    ></v-text-field>
                    <v-text-field
                      v-else
                      v-model="ordenAfacturar.receptor.codigo_postal"
                      label="Codigo postal*"
                      type="text"
                      :rules="[rules.required]"
                      validate-on-blur
                      placeholder="65000"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col v-if="!isGeneralPublic" cols="12" sm="6">
                    <v-text-field
                      v-if="rfc != null"
                      v-model="rfc.calle"
                      label="Calle*"
                      v-uppercase
                      type="text"
                      :rules="[rules.required]"
                      validate-on-blur
                      disabled
                    ></v-text-field>
                    <v-text-field
                      v-else
                      v-model="ordenAfacturar.receptor.calle"
                      label="Calle*"
                      v-uppercase
                      type="text"
                      :rules="[rules.required]"
                      validate-on-blur
                      placeholder="Calle"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col v-if="!isGeneralPublic" cols="12" sm="6">
                    <v-text-field
                      v-if="rfc != null"
                      v-model="rfc.numero_exterior"
                      label="Numero exterior*"
                      type="text"
                      v-uppercase
                      :rules="[rules.required]"
                      validate-on-blur
                      disabled
                    ></v-text-field>
                    <v-text-field
                      v-else
                      v-model="ordenAfacturar.receptor.numero_exterior"
                      label="Numero exterior*"
                      v-uppercase
                      type="text"
                      :rules="[rules.required]"
                      validate-on-blur
                      placeholder="#"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col v-if="!isGeneralPublic" cols="12" sm="6">
                    <v-text-field
                      v-if="rfc != null"
                      v-model="rfc.numero_interior"
                      label="Numero interior"
                      v-uppercase
                      type="text"
                      disabled
                    ></v-text-field>
                    <v-text-field
                      v-else
                      v-model="ordenAfacturar.receptor.numero_interior"
                      label="Numero interior"
                      v-uppercase
                      type="text"
                      placeholder="#"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col v-if="!isGeneralPublic" cols="12" sm="6">
                    <v-text-field
                      v-if="rfc != null"
                      v-model="rfc.colonia"
                      label="Colonia*"
                      v-uppercase
                      type="text"
                      :rules="[rules.required]"
                      validate-on-blur
                      disabled
                    ></v-text-field>
                    <v-text-field
                      v-else
                      v-model="ordenAfacturar.receptor.colonia"
                      label="Colonia*"
                      v-uppercase
                      type="text"
                      :rules="[rules.required]"
                      validate-on-blur
                      placeholder="Colonia"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col v-if="!isGeneralPublic" cols="12" sm="6">
                    <v-text-field
                      v-if="rfc != null"
                      v-model="rfc.municipio"
                      label="Municipio*"
                      v-uppercase
                      type="text"
                      :rules="[rules.required]"
                      validate-on-blur
                      disabled
                    ></v-text-field>
                    <v-text-field
                      v-else
                      v-model="ordenAfacturar.receptor.municipio"
                      label="Municipio*"
                      v-uppercase
                      type="text"
                      :rules="[rules.required]"
                      validate-on-blur
                      placeholder="Municipio"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col v-if="!isGeneralPublic" cols="12" sm="6">
                    <v-text-field
                      v-if="rfc != null"
                      v-model="rfc.estado"
                      label="Estado*"
                      v-uppercase
                      type="text"
                      :rules="[rules.required]"
                      validate-on-blur
                      disabled
                    ></v-text-field>
                    <v-text-field
                      v-else
                      v-model="ordenAfacturar.receptor.estado"
                      label="Estado*"
                      v-uppercase
                      type="text"
                      :rules="[rules.required]"
                      validate-on-blur
                      placeholder="Estado"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col v-if="!isGeneralPublic" cols="12" sm="6">
                    <v-text-field
                      v-if="rfc != null"
                      v-model="rfc.pais"
                      label="Pais*"
                      v-uppercase
                      type="text"
                      :rules="[rules.required]"
                      validate-on-blur
                      disabled
                    ></v-text-field>
                    <v-text-field
                      v-else
                      v-model="ordenAfacturar.receptor.pais"
                      label="Pais*"
                      v-uppercase
                      type="text"
                      :rules="[rules.required]"
                      validate-on-blur
                      placeholder="Pais"
                      required
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-divider></v-divider>
                <b>Parametros de facturación</b>
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                      v-model="mano_obra"
                      v-if="tieneManoObra"
                      label="Mano de obra"
                      placeholder="Cambia el concepto de mano de obra aqui."
                      filled
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-autocomplete
                      v-model="ordenAfacturar.uso_cfdi"
                      :items="cfdis"
                      filled
                      item-value="clave"
                      item-text="nombre"
                      label="Concepto de pago*"
                      :rules="[rules.required]"
                      validate-on-blur
                      :disabled="isGeneralPublic"
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-autocomplete
                      v-model="ordenAfacturar.metodo_pago"
                      :items="metodosPago"
                      filled
                      item-value="clave"
                      item-text="nombre"
                      label="Metodo de pago*"
                      :disabled="isGeneralPublic"
                      :rules="[rules.required]"
                      validate-on-blur
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-autocomplete
                      v-model="ordenAfacturar.forma_pago"
                      :items="formasPago"
                      filled
                      item-value="clave"
                      item-text="nombre"
                      label="Forma de pago*"
                      :rules="[rules.required]"
                      validate-on-blur
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-autocomplete
                      v-model="ordenAfacturar.tipo_cfdi"
                      :items="tiposCfdi"
                      filled
                      item-value="clave"
                      item-text="nombre"
                      label="Tipo de comprobantes*"
                      :rules="[rules.required]"
                      validate-on-blur
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12">
                    <v-textarea
                      :rows="2"
                      v-model="ordenAfacturar.observacion"
                      filled
                      label="Observaciones"
                    ></v-textarea>
                  </v-col>
                  <v-checkbox
                    v-model="ordenAfacturar.aplicaIVA"
                    label="Declarar impuestos"
                  ></v-checkbox>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions class="btns-container">
              <v-btn text @click="cerrarFactura">Cancelar</v-btn>
              <v-btn
                text
                :disabled="handleFacturaDisabled"
                @click="facturarVenta()"
                >Generar factura</v-btn
              >
            </v-card-actions>
          </v-card>
        </template>
      </v-dialog>
    </v-row>
    <ModalOrdenDigital
      v-if="ordenDigital"
      :imgEmpleado="imgEmpleado.imagen"
      :imgCliente="imgCliente.imagen"
      :orden="ordenSeleccionado"
      :serverError="errorServerOrdenDigital"
      @abrirFirmaDigital="abrirFirmaDigital"
      @closeModal="ordenDigital = false"
      @guardar="guardarOrdenDigital"
    />
    <ModalFirmaDigital
      v-if="firmaDigital"
      @closeModal="closeFirmaDigital"
      @guardar="guardarFirmaDigital"
    />
    <ModalTicketTecnico v-if="showTicketTecnico" :datos="datosTicket" @closeModal="showTicketTecnico = false;datosTicket = {}"/>
  </v-container>
</template>
<script>
import ApiService from "../../services/apis";
import ReportService from "../../services/reports";
import NuevoCliente from "../pages/Cliente";
import Salida from "../pages/SalidaVehiculo";
import Contrato from "../pages/Contrato";
import Spinner from "../Loaders/spinner.vue";
import { validateNoErrors } from "../../helpers/helpers";
import moment from "moment";
import Swal from "sweetalert2";
import ModalOrdenDigital from "../Modales/ModalOrdenDigital.vue";
import ModalFirmaDigital from "../Modales/ModalFirmaDigital.vue";
import { FormatMoney } from "format-money-js";
import ModalTicketTecnico from "../Modales/ModalTicketTecnico.vue";
export default {
  name: "orden",
  data() {
    return {
      showTicketTecnico: false,
      datosTicket: {},
      fm: new FormatMoney({
        decimals: 0,
      }),
      regimen: [
        { value: 601, text: "General de Ley Personas Morales" },
        { value: 603, text: "Personas Morales con Fines no Lucrativos" },
        {
          value: 605,
          text: "Sueldos y Salarios e Ingresos Asimilados a Salarios",
        },
        { value: 606, text: "Arrendamiento" },
        { value: 607, text: "Régimen de Enajenación o Adquisición de Bienes" },
        { value: 608, text: "Demás ingresos" },
        { value: 609, text: "Consolidación" },
        {
          value: 610,
          text: "Residentes en el Extranjero sin Establecimiento Permanente en México",
        },
        { value: 611, text: "Ingresos por Dividendos (socios y accionistas)" },
        {
          value: 612,
          text: "Personas Físicas con Actividades Empresariales y Profesionales",
        },
        { value: 614, text: "Ingresos por intereses" },
        {
          value: 615,
          text: "Régimen de los ingresos por obtención de premios",
        },
        { value: 616, text: "Sin obligaciones fiscales" },
        {
          value: 620,
          text: "Sociedades Cooperativas de Producción que optan por diferir sus ingresos",
        },
        { value: 621, text: "Incorporación Fiscal" },
        {
          value: 622,
          text: "Actividades Agrícolas, Ganaderas, Silvícolas y Pesqueras",
        },
        { value: 623, text: "Opcional para Grupos de Sociedades" },
        { value: 624, text: "Coordinados" },
        {
          value: 625,
          text: "Régimen de las Actividades Empresariales con ingresos a través de Plataformas Tecnológicas",
        },
        { value: 626, text: "Régimen Simplificado de Confianza" },
        { value: 628, text: "Hidrocarburos" },
        {
          value: 629,
          text: "De los Regímenes Fiscales Preferentes y de las Empresas Multinacionales",
        },
        { value: 630, text: "Enajenación de acciones en bolsa de valores" },
      ],
      rules: {
        required: (value) => !!value || "Requerido.",
        regex: (v) => /^\d{10}$/.test(v) || "Deben ser 10 digitos",
        regexEmail: (v) =>
          /^[^@]+@[^@]+\.[a-zA-Z;@.\d\w\D\W]{2,}$/.test(v) ||
          "Formato no válido",
        regexRZ: (v) =>
          !/(S.A. DE C.V.)$|(S.A.)$|(S.A.S.)$|(S.A. de C.V.)$|(S. de R.L.)$|(S.C.)$/gi.test(
            v
          ) || "Formato no válido",
        regexRFC: (v) => /^[\da-zA-Z]{12,13}$/gi.test(v) || "Formato no válido",
      },
      loader: true,
      cambio_images: null,
      sortBy: "order",
      switchOrden: true,
      sortDesc: true,
      search: "",
      dialog: false,
      modal: false,
      expanded: [],
      headers: [],
      ordenes: [
        {
          services: [
            {
              service: {
                name: "",
                description: "",
              },
            },
          ],
        },
      ],
      options: {},
      id: null,
      status: null,
      service: null,
      mecanico: null,
      servicio: null,
      facturar: false,
      ordenAfacturar: {
        order_id: null,
        receptor_id: null,
        aplicaIVA: false,
        receptor: {
          name: null,
          first_lastname: null,
          second_lastname: null,
          telephones: null,
          razon_social: null,
          rfc: null,
          email: null,
          codigo_postal: null,
          regimen_fiscal: null,
          calle: null,
          numero_exterior: null,
          numero_interior: null,
          colonia: null,
          municipio: null,
          estado: null,
          pais: "México",
        },
        uso_cfdi: null,
        tipo_cfdi: "I",
        forma_pago: null,
        metodo_pago: null,
        logo: null,
        user: null,
      },
      rfcs: null,
      rfc: null,
      cfdis: null,
      tiposCfdi: [
        { clave: "I", nombre: "Comprobante de Ingreso" },
        { clave: "E", nombre: "Comprobante de Egreso" },
        { clave: "T", nombre: "Comprobante de Traslado" },
        { clave: "N", nombre: "Comprobante de Nómina" },
        { clave: "P", nombre: "Comprobante de Pago" },
      ],
      metodosPago: null,
      formasPago: null,
      tieneManoObra: false,
      mano_obra: "",
      ordenDigital: false,
      firmaDigital: false,
      tipoFirma: 0,
      imgCliente: {
        file: null,
        imagen: null,
      },
      imgEmpleado: {
        file: null,
        imagen: null,
      },
      ordenSeleccionado: null,
      errorServerOrdenDigital: null,
      btnTextOrdenDigital: "Descargar orden digital",
    };
  },
  components: {
    NuevoCliente,
    Salida,
    Contrato,
    Spinner,
    ModalOrdenDigital,
    ModalFirmaDigital,
    ModalTicketTecnico
  },
  computed: {
    handleFacturaDisabled() {
      return this.validateDisabled();
    },
    isGeneralPublic() {
      if (this.rfc != null) {
        return this.rfc?.rfc == "XAXX010101000" ? true : false;
      } else {
        return this.ordenAfacturar?.receptor?.rfc == "XAXX010101000"
          ? true
          : false;
      }
    },
  },
  created() {
    this.initialize();
    this.getRfcData();
    this.servicios();
    this.mecanicos();
    this.$bus.$off("actualizaOrden");
    this.$bus.$on("actualizaOrden", async () => {
      this.switchOrden = true;
      this.initialize();
    });
  },

  methods: {
    getNombreMecanico(mecanico) {
      if (!mecanico) return "No disponible";
      return `${mecanico[0]?.name || ""} ${mecanico[0]?.first_lastname || ""} ${
        mecanico[0]?.second_lastname || ""
      }`;
    },
    validateDisabled() {
      const { receptor, uso_cfdi, metodo_pago, forma_pago, tipo_cfdi } =
        this.ordenAfacturar;
      if (!receptor) return true;

      if (this.rfc != null) {
        const {
          email,
          razon_social,
          rfc,
          codigo_postal,
          regimen_fiscal,
          calle,
          numero_exterior,
          colonia,
          municipio,
          estado,
          pais,
        } = this.rfc;
        const correoValid = validateNoErrors("email", email);
        const nombreValid = validateNoErrors("razonSocial", razon_social);
        const rfcValid = validateNoErrors("rfc", rfc);
        if (
          this.isGeneralPublic &&
          razon_social &&
          correoValid &&
          nombreValid &&
          rfcValid &&
          uso_cfdi &&
          metodo_pago &&
          forma_pago &&
          regimen_fiscal
        )
          return false;
        if (
          razon_social &&
          correoValid &&
          nombreValid &&
          rfcValid &&
          uso_cfdi &&
          metodo_pago &&
          forma_pago &&
          codigo_postal &&
          regimen_fiscal &&
          calle &&
          numero_exterior &&
          colonia &&
          municipio &&
          estado &&
          pais &&
          tipo_cfdi
        )
          return false;
      }
      const {
        razon_social,
        email,
        rfc,
        codigo_postal,
        regimen_fiscal,
        calle,
        numero_exterior,
        colonia,
        municipio,
        estado,
        pais,
        name,
        first_lastname,
        second_lastname,
        telephones,
      } = receptor;
      const correoValid = validateNoErrors("email", email);
      const nombreValid = validateNoErrors("razonSocial", razon_social);
      const rfcValid = validateNoErrors("rfc", rfc);
      const telephoneValid = validateNoErrors("telephones", telephones);
      if (
        this.isGeneralPublic &&
        name &&
        first_lastname &&
        second_lastname &&
        telephoneValid &&
        razon_social &&
        correoValid &&
        nombreValid &&
        rfcValid &&
        uso_cfdi &&
        metodo_pago &&
        forma_pago &&
        regimen_fiscal
      )
        return false;
      if (
        name &&
        first_lastname &&
        second_lastname &&
        telephoneValid &&
        razon_social &&
        correoValid &&
        nombreValid &&
        rfcValid &&
        uso_cfdi &&
        metodo_pago &&
        forma_pago &&
        codigo_postal &&
        regimen_fiscal &&
        calle &&
        numero_exterior &&
        colonia &&
        municipio &&
        estado &&
        pais &&
        tipo_cfdi
      )
        return false;
      return true;
    },
    async initialize() {
      this.loader = true;
      if (this.switchOrden) {
        try {
          this.headers = [
            {
              text: "Orden",
              align: "start",
              value: "order",
            },
            { text: "Nombre", value: "cliente" },
            { text: "Vehículo", value: "vehicleWithPlate" },
            { text: "Detalle", value: "detail" },
            { text: "Estatus del servicio", value: "status" },
            { text: "Acciones", value: "actions" },
          ];
          const ordenes = await ApiService.ordenFiltro({
            status: { $nin: ["4", "0"] },
          });
          this.ordenes = ordenes?.data?.map((orden) => {
            const firstLastname = orden?.client?.first_lastname || ""
            const name = orden?.client?.name || ""
            orden.cliente =  `${name} ${firstLastname}`

            const model = orden?.vehicle?.model?.name || ""
            const license_plate = orden?.vehicle?.license_plate || ""
            const mileage = orden?.km?.toLocaleString() || ""
            orden.vehicleWithPlate = `${model} - KM: ${mileage} - ${license_plate}`
            return orden;
          });
          this.loader = false;
        } catch (err) {
          this.loader = false;
          return err;
        }
      } else {
        this.headers = [
          {
            text: "Orden",
            align: "start",
            value: "order",
          },
          { text: "Nombre", value: "cliente" },
          { text: "Vehículo", value: "vehicle.model.name" },
          { text: "Año", value: "vehicle.year" },
          { text: "Placas", value: "vehicle.license_plate" },
          { text: "Detalle", value: "detail" },
          { text: "Estatus del servicio", value: "status" },
          { text: "Fin servicio", value: "delivered_at" },
        ];
        try {
          const ordenes = await ApiService.ordenFiltro({ status: "4" });
          this.ordenes = ordenes.data.map((orden) => {
            orden.cliente =
              orden.client?.name + " " + (orden.client?.first_lastname || "");
            orden.delivered_at = orden.delivered_at
              ? this.formatDate(orden.delivered_at)
              : this.formatDate(orden.updatedAt);
            return orden;
          });
          this.loader = false;
        } catch (err) {
          this.loader = false;
          return err;
        }
      }
    },
    formatDate(date) {
      if (!date) return "No disponible";
      return moment(date).utc().format("YYYY-MM-DD");
    },
    async getRfcData() {
      try {
        this.loader = true;
        const [cdfi, data, dataFp, dataRfc] = await Promise.all([
          ApiService.ConceptoPago(),
          ApiService.MetodosPago(),
          ApiService.FormaPago(),
          ApiService.RFC(),
        ]);
        this.cfdis = cdfi;
        this.metodosPago = data;
        this.formasPago = dataFp;
        this.rfcs = dataRfc;
        this.loader = false;
      } catch (err) {
        this.loader = false;
        return err;
      }
    },
    puntoDeVenta(orden) {
      // this.$bus.$emit('obtenerOrden', orden)
      this.$router.push({
        name: "ventaConOrden",
        params: {
          orden: orden,
        },
      });
    },
    cerrarFactura() {
      (this.ordenAfacturar = {
        order_id: null,
        receptor_id: null,
        aplicaIVA: false,
        receptor: {
          name: null,
          first_lastname: null,
          second_lastname: null,
          telephones: null,
          razon_social: null,
          rfc: null,
          email: null,
          codigo_postal: null,
          regimen_fiscal: null,
          calle: null,
          numero_exterior: null,
          numero_interior: null,
          colonia: null,
          municipio: null,
          estado: null,
          pais: "México",
        },
        uso_cfdi: null,
        tipo_cfdi: "I",
        forma_pago: null,
        metodo_pago: null,
        logo: null,
        user: null,
      }),
        (this.facturar = false);
    },
    modalCambiarStatus(id, status) {
      // console.log(status)
      // if(status>=4)
      //   return
      this.id = id;
      this.status = status;
      this.dialog = true;
    },
    cambiarStatus() {
      // if(this.status>=4)
      //   return
      let estatus = parseInt(this.status);
      estatus = estatus + 1;
      ApiService.ordenEditar(this.id, { status: estatus }).then(() => {
        this.initialize();
        this.dialog = false;
      });
    },
    toBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    },

    async onFileChange(files) {
      const filePathsPromises = [];
      files.forEach((file) => {
        filePathsPromises.push(this.toBase64(file));
      });
      const filePaths = await Promise.all(filePathsPromises);
      this.cambio_images = filePaths.map((base64File) => ({
        base64File,
      }));
    },
    subirImg(item) {
      ApiService.ordenEditarImg(item._id, { images: this.cambio_images }).then(
        () => {
          this.initialize();
          this.dialog = false;
        }
      );
      //aqui se subiran las imagenes
    },
    editar(item) {
      this.modal = true;
      this.service = item.services;
      this.id = item._id;
      this.saldo_favor = item.saldo_favor;
    },
    servicios() {
      ApiService.servicio().then((servicio) => {
        this.servicio = servicio.data;
      });
    },
    mecanicos() {
      ApiService.empleadoByFilter({
        status: 1,
        position: "5ff1449743100e0011266263",
      }).then((mecanico) => {
        this.mecanico = mecanico.data;
      });
    },
    guardarServicio() {
      let body = [];
      this.service.forEach((item) => {
        body.push({
          _id: item._id,
          mechanics: [item?.mechanics[0]?._id],
          service: item.service._id,
          detail: item.detail,
        });
      });
      // console.log(body)

      ApiService.servicioHistorialEditar(body).then((data) => {
        console.log(data);
        ApiService.ordenEditar(this.id, { saldo_favor: this.saldo_favor }).then(
          () => {
            this.modal = false;

            this.initialize();
            this.saldo_favor = null;
          }
        );
      });
    },
    abrirFacturacion(id, orden) {
      this.facturar = true;
      this.ordenAfacturar.order_id = id;
      ReportService.ventasPorOrden(orden).then((resp) => {
        this.tieneManoObra = false;
        resp.data.sales_details.map((item) => {
          if (item.type == 2) {
            if (item.service.name.includes("MANO DE OBRA")) {
              this.tieneManoObra = true;
            }
          }
        });
      });
    },
    async facturarVenta() {
      this.ordenAfacturar.user = JSON.parse(
        sessionStorage.getItem("sesion")
      ).employee._id;
      this.ordenAfacturar.logo =
        "https://sistema.automotrizrm.com/img/favicon.5c9a3179.png";
      if (this.rfc == null) {
        this.ordenAfacturar.receptor_id = null;
      }
      if (this.rfc != null) {
        this.ordenAfacturar.receptor_id = this.rfc._id;
        this.ordenAfacturar.receptor.name = this.rfc.name;
        this.ordenAfacturar.receptor.first_lastname = this.rfc.first_lastname;
        this.ordenAfacturar.receptor.second_lastname = this.rfc.second_lastname;
        this.ordenAfacturar.receptor.telephones = this.rfc?.telephones[0];
        this.ordenAfacturar.receptor.email = this.rfc.email;
        this.ordenAfacturar.receptor.razon_social = this.rfc.razon_social;
        this.ordenAfacturar.receptor.rfc = this.rfc.rfc;
        this.ordenAfacturar.receptor.codigo_postal = this.rfc.codigo_postal;
        this.ordenAfacturar.receptor.regimen_fiscal = this.rfc.regimen_fiscal;
        this.ordenAfacturar.manoObra = this.mano_obra;
        this.ordenAfacturar.receptor.calle = this.rfc.calle;
        this.ordenAfacturar.receptor.numero_exterior = this.rfc.numero_exterior;
        this.ordenAfacturar.receptor.numero_interior = this.rfc.numero_interior;
        this.ordenAfacturar.receptor.colonia = this.rfc.colonia;
        this.ordenAfacturar.receptor.municipio = this.rfc.municipio;
        this.ordenAfacturar.receptor.estado = this.rfc.estado;
        this.ordenAfacturar.receptor.pais = this.rfc.pais;
      }

      try {
        await ApiService.crearFacturaOrden(this.ordenAfacturar);
        Swal.fire({
          icon: "success",
          title: "Atención!",
          text: `Factura generada`,
          showConfirmButton: true,
          confirmButtonText: "Enterado",
        });
        this.facturar = false;
        this.initialize();
      } catch (err) {
        return err;
      }
    },
    async abrirOrdenDigital(orden) {
      this.ordenSeleccionado = orden;
      try {
        if (orden.sign_flag) {
          this.loader = true;
          this.btnTextOrdenDigital = "Descargando...";
          const response = await ApiService.descargarOrdenDigital(orden._id);
          this.downloadFile(
            response,
            "application/pdf",
            `Orden-digital-${orden.order}`
          );
          this.btnTextOrdenDigital = "Descargar orden digital";
          this.loader = false;
        } else {
          this.imgEmpleado.file = null;
          this.imgEmpleado.imagen = null;
          this.imgCliente.file = null;
          this.imgCliente.imagen = null;
          this.ordenDigital = true;
        }
      } catch (error) {
        this.loader = false;
        this.btnTextOrdenDigital = "Descargar orden digital";
      }
    },
    async ticketTecnico(item) {
      this.datosTicket = {
        fecha: item.createdAt,
        cliente: item.client.full_name,
        telefono: item.client.telephones[0],
        marca: item.vehicle.model.brand.name,
        modelo: item.vehicle.model.name,
        color: item.vehicle.colour.toUpperCase(),
        placas: item.vehicle?.license_plate,
        motor: 'NA',
        cilindros: item.vehicle.cylenders,
        kilometraje: item.km || item.vehicle?.mileage,
        transmision: 'NA',
        tipoMotor: 'NA',
        traccion: 'NA',
        aireAcondicionado: item.air,
        candado: 'NA',
        lavado: item.washed,
        reporteCliente: item.detail, 
      }
      try {
        this.showTicketTecnico = true;
      } catch (error) {
        this.showTicketTecnico = false;
      }

    },
    abrirFirmaDigital(tipo) {
      this.tipoFirma = tipo;
      this.ordenDigital = false;
      this.firmaDigital = true;
    },
    closeFirmaDigital() {
      this.firmaDigital = false;
      this.ordenDigital = true;
    },
    guardarFirmaDigital(data) {
      this.errorServerOrdenDigital = null;
      if (this.tipoFirma === 1) {
        this.imgEmpleado.file = data.file;
        this.imgEmpleado.imagen = data.imagen;
      } else {
        this.imgCliente.file = data.file;
        this.imgCliente.imagen = data.imagen;
      }
      this.closeFirmaDigital();
    },
    validarOrdenDigital() {
      let valid = true;

      if (!this.imgCliente.file) valid = false;
      if (!this.imgEmpleado.file) valid = false;

      return valid;
    },
    async guardarOrdenDigital() {
      try {
        this.errorServerOrdenDigital = null;
        if (this.validarOrdenDigital()) {
          this.loader = true;
          const formData = new FormData();
          formData.append("id", this.ordenSeleccionado._id);
          formData.append("firma1", this.imgCliente.file);
          formData.append("firma2", this.imgEmpleado.file);
          await ApiService.guardarOrdenDigital(formData);
          this.ordenDigital = false;
          this.loader = false;
          this.expanded[0].sign_flag = true;
          this.showSwalModal(
            "success",
            "Atención!",
            `Orden digital guardada exitosamente`
          );
        } else this.errorServerOrdenDigital = "Porfavor ingresar ambas firmas";
      } catch (error) {
        console.log(error);
        this.loader = false;
        this.errorServerOrdenDigital = error;
      }
    },
    showSwalModal(icon, title, text) {
      Swal.fire({
        icon,
        title,
        text,
        showConfirmButton: true,
        confirmButtonText: "Enterado",
      });
    },
    downloadFile(file, fileType, fileName) {
      const blob = new Blob([file], { type: fileType });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = fileName;
      link.click();
    },
  },
  watch: {
    isGeneralPublic() {
      if (this.isGeneralPublic) {
        this.ordenAfacturar.uso_cfdi = "S01";
        this.ordenAfacturar.metodo_pago = "PUE";
        this.ordenAfacturar.receptor.regimen_fiscal = 616;
      }
    },
    switchOrden() {
      console.log("entro");
      this.options.page = 1;
    },
  },
};
</script>
<style scoped>
.v-carousel {
  max-width: 525px;
}
.btns-container {
  justify-content: space-between;
}
.capitalize {
  text-transform: capitalize;
}
.absolute {
  position: relative;
  z-index: 10000;
}
.card-container-ord {
  display: flex;
  flex-direction: column;
  align-content: center;
  justify-content: center;
}
.item-center {
  align-self: center;
}
.btn {
  margin-right: 10px;
}
.btnOrdenDigital i {
  margin-right: 4px;
}
/* Refrescar y Nueva orden viajan juntos a la derecha cuando el título se parte */
.orden-acciones {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-left: auto;
}
</style>
